import React, { ReactNode } from "react";
import { Paper, Table as MuiTable, TableContainer, ThemeProvider, createTheme } from "@mui/material";

type TableProps = {
  className?: string;
  children: ReactNode;
};

const Table = ({ className, children }: TableProps) => {
  const theme = createTheme({
    components: {
      MuiTable: {
        styleOverrides: {
          root: {
            borderCollapse: "separate",
            borderSpacing: "0 10px"
          }
        }
      },
      MuiTableHead: {
        styleOverrides: {
          root: {
            "th": {
              backgroundColor: "#FAFAFA !important"
            }
          }
        }
      },
      MuiTableRow: {
        styleOverrides: {
          root: {
            "&.Mui-selected": {
              backgroundColor: "#EFF2FD !important",
              "td": {
                borderTop: "1px solid #96A3EA",
                borderBottom: "1px solid #96A3EA",
                "&:first-of-type": {
                  borderLeft: "1px solid #96A3EA"
                },
                "&:last-of-type": {
                  borderRight: "1px solid #96A3EA"
                }
              }
            },
            "&:hover": {
              backgroundColor: "#EFF2FD"
            },
            "th, td": {
              padding: "5px 10px !important"
            },
            "&:nth-of-type(odd)": {
              backgroundColor: "transparent"
            },
            "&:nth-of-type(even)": {
              backgroundColor: "#FAFAFA"
            },
            "th:first-of-type, td:first-of-type": {
              borderRadius: "4px 0 0 4px"
            },
            "th:last-of-type, td:last-of-type": {
              borderRadius: "0 4px 4px 0"
            }
          }
        }
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            border: "none"
          }
        }
      }
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <TableContainer component={Paper} elevation={0} className={className}>
        <MuiTable>
          {children}
        </MuiTable>
      </TableContainer>
    </ThemeProvider>
  );
};

export default Table;